import React from 'react';
import DealerHelper from '../Helpers/DealerHelper.js';

const Dealer = ({ dealer, setSelectedDealer, isOnline, activeCategoryName, translations, index }) => {
  const shouldShowDealerLabel = () => {
    return dealer.PartnerRating === 10 || dealer.PartnerRating === 11 ? true : false;
  };

  const getDealerLabel = () => {
    return dealer.PartnerRating === 10
      ? translations.Rating10Label
      : dealer.PartnerRating === 11
        ? translations.Rating11Label
        : '';
  };

  const shouldShowServiceLabel = () => {
    return dealer.DealerServices.find((service) => service.ServiceKey === 'service_repair') != null;
  };

  const handleClick = () => {
    try {
      google.tagmanager.add({
        dealerLocatorClickOutType: 'website',
        dealerLocatorSelectedCategory: activeCategoryName,
        dealerLocatorDealerName: dealer.Name,
        dealerLocatorDealerType: !isOnline ? 'regular' : 'online',
        dealerLocatorDealerCity: dealer.City || '',
        event: 'dealerLocatorClickOut',
      });
    } catch (error) {}
    window.open(dealer.Url, '_blank');
  };

  if (!isOnline) {
    return (
      <li className={shouldShowDealerLabel() || shouldShowServiceLabel() ? 'rating-special' : ''}>
        <div className="number-container position-relative">
          <div className="number position-absolute">{index + 1}.</div>
        </div>
        <div className="content">
          <a
            className="dealer-link"
            data-component-label="Dealer link"
            href={DealerHelper.getDealerUrl(dealer.Id)}
            onClick={(e) => {
              e.preventDefault();
              setSelectedDealer(dealer);
              DealerHelper.setDealerUrl(dealer.Id);
            }}
          >
            {(shouldShowDealerLabel() || shouldShowServiceLabel()) && (
              <div className="special-labels-container">
                {shouldShowDealerLabel() && <div className="rating-special-label">{getDealerLabel()}</div>}
                {shouldShowServiceLabel() && (
                  <div className="servicepart-special-label">{translations.ServiceRepairLabel}</div>
                )}
              </div>
            )}
            <h6 className="dealer-name">
              {dealer.Name}
              <i className="fa-solid fa-angle-right dealer-expand"></i>
            </h6>
            <span className="dealer-city">{dealer.City}</span>
            <br />
          </a>
          <a onClick={handleClick}>{dealer.Url}</a>
        </div>
      </li>
    );
  } else {
    return (
      <li className={`flex flex-column ${shouldShowDealerLabel() ? 'rating-special' : ''}`}>
        {shouldShowDealerLabel() && <div className="rating-special-label">{getDealerLabel()}</div>}
        <h6 className="dealer-name">{dealer.Name}</h6>
        <a onClick={handleClick}>{dealer.Url}</a>
      </li>
    );
  }
};

export default Dealer;
